import React, { useEffect } from 'react';
import {
  DietIdEnum,
  DietModeType,
  FormikRadioInput as Radio,
} from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';
import useSteps from '../StepContext/useSteps';
import { dietSettings } from '../types';
import { useFormikContext } from 'formik';

export const DietMode: React.FC = () => {
  const { t } = useTranslator();
  const { dietModes } = useSteps();
  const { values, setFieldValue } = useFormikContext<dietSettings>();

  useEffect(() => {
    if (values.dietType === DietIdEnum.DIET_ID_GLP1) {
      setFieldValue('dietMode', DietModeType.slimming);
    }
  }, [setFieldValue, values.dietType]);

  const enabledModes = dietModes?.filter((dietMode) =>
    dietMode.disableCondition ? !dietMode.disableCondition(values) : true
  );
  const disabledModes = dietModes?.filter((dietMode) =>
    dietMode.disableCondition ? dietMode.disableCondition(values) : false
  );

  return (
    <>
      <h2 className="mb-xl title-large semi-bold">{t('app.goalSettings.goal.headline')}</h2>

      {enabledModes?.map((dietMode) => (
        <Radio name="dietMode" value={dietMode.value} key={dietMode.value}>
          <strong>{t(dietMode.optionTitle)}</strong>
          <p className="mb-0">{t(dietMode.optionDescription)}</p>
        </Radio>
      ))}

      {disabledModes && disabledModes.length > 0 && (
        <>
          <hr className="my-l" />
          <p className="text-start black small">{t('goalSettings.goal.notAvailable.headline')}</p>

          {disabledModes.map((dietMode) => (
            <Radio name="dietMode" value={dietMode.value} key={dietMode.value} disabled>
              <div>
                <strong>{t(dietMode.optionTitle)}</strong>
                <p className="mb-0">{t(dietMode.optionDescription)}</p>
              </div>
            </Radio>
          ))}
        </>
      )}
    </>
  );
};

export default DietMode;
